type ENV = {
    REACT_APP_TARGET_NETWORK: number;
    REACT_APP_TARGET_NETWORK_MSG?: string;
    WAAS_CLIENT_ID?: string;
    WAAS_CLIENT_SECRET?: string;
    ABC_SERVER_ADDRESS: string;
    ABC_SERVICE_ID: string;
    REACT_APP_API_SERVER?: string;
    WAAS_BASE_URL: string;
};

const development: ENV = {
    REACT_APP_TARGET_NETWORK: 1001, // baobab
    REACT_APP_TARGET_NETWORK_MSG: '',
    WAAS_CLIENT_ID: '34OsnksCks29fXWBJwBaCW',
    WAAS_CLIENT_SECRET: '2h1K6R8ZAoUaUZb49lwP3H17JL3f8fARJadnXlFI/OvY',
    ABC_SERVER_ADDRESS: 'dev-api.waas.myabcwallet.com',
    ABC_SERVICE_ID: 'https://mw.myabcwallet.com',
    WAAS_BASE_URL: 'https://dev-api.waas.myabcwallet.com',
    // REACT_APP_API_SERVER: 'http://localhost:5001',
    REACT_APP_API_SERVER: process.env.REACT_APP_API_SERVER,
};

const staging: ENV = {
    REACT_APP_TARGET_NETWORK: 8217, // baobab
    REACT_APP_TARGET_NETWORK_MSG: '',
    WAAS_CLIENT_ID: 'aN+PFtNnQUpafQA2M65yzm',
    WAAS_CLIENT_SECRET: '83qbi2bEQF9bh9To55ESqw1zXr3us4AkHbJ3NyONVUyF',
    ABC_SERVER_ADDRESS: 'stg-api.waas.myabcwallet.com',
    ABC_SERVICE_ID: 'https://mw.myabcwallet.com',
    WAAS_BASE_URL: 'https://stg-api.waas.myabcwallet.com',
    // REACT_APP_API_SERVER: 'http://localhost:5001',
    REACT_APP_API_SERVER: process.env.REACT_APP_API_SERVER,
};

const production: ENV = {
    REACT_APP_TARGET_NETWORK: 8217, // mainnet
    REACT_APP_TARGET_NETWORK_MSG: '',
    WAAS_CLIENT_ID: '',
    WAAS_CLIENT_SECRET: '',
    ABC_SERVER_ADDRESS: 'api.waas.myabcwallet.com',
    ABC_SERVICE_ID: 'https://mw.myabcwallet.com',
    WAAS_BASE_URL: 'https://api.waas.myabcwallet.com',
    // REACT_APP_API_SERVER: 'http://localhost:5001',
    REACT_APP_API_SERVER: process.env.REACT_APP_API_SERVER,
};

const env =
    process.env.REACT_APP_PHASE === 'staging'
        ? staging
        : process.env.REACT_APP_PHASE === 'production'
        ? production
        : development;

export default env;
